import Alerts from 'lib/alerts';
import Log from 'lib/log';
import moment from 'moment';
import template from 'employer/templates/payroll/stepTwo/Payslips.ejs';
import PayslipView from 'commons/views/Payslip';
import LeaveRequests from 'newCollections/leave-requests.js';

const log = Log('payslips-slides');

module.exports = Backbone.View.extend({
    events: {
        'change .js-employee-select': 'selectEmployee',
        'beforeChange .js-slides': 'beforeChangeSlide',
        'afterChange .js-slides': 'afterChangeSlide',
        'click .js-prev-slide:not(.js-disabled)': 'prevSlide',
        'click .js-next-slide:not(.js-disabled)': 'nextSlide'
    },

    activeSlideView: null,
    nextSlideView: null,

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payslips:         null,
            payslipDetails:   null,
            companyLocation:  null
        });

        this.render();
    },

    // TODO it is a big and multiplied method, refactor it later
    fetchBalance: function(payslip) {
        const fetchYearlyBalances = () => {
            return app.leaveTypes.fetchBalances(
                payslip.getEmployee(),
                payslip.getPayroll().getPeriod().endOf('month').toDate()
            );
        };

        const transformYearly = leaveTypes => {
            return leaveTypes.map(leaveType => {
                const name = leaveType.get('name');
                const id = leaveType.id;
                const entitled = leaveType.getEntitled() || 0;
                const taken = leaveType.getTaken() || 0;
                const remaining = Math.max(0, entitled - taken);
                return {
                    id,
                    name,
                    entitled,
                    remaining,
                    taken
                };
            });
        };

        const mergeBalances = (yearly, monthly) => {
            const obligated = _.filter(yearly, balance => {
                return [
                    'Medical Leave',
                    'Annual Leave',
                    'Unpaid Leave',
                ].includes(balance.name);
            });
            const yearlyHasInMontly = _.filter(yearly, balance => (
                _.map(monthly, t => t.id)
                    .includes(balance.id) && balance.taken > 0
            ))
            .concat(obligated);

            const mergeBalances = _.map(yearlyHasInMontly, balance => {
                const sameMonthlyBalance = monthly
                    .find(t => t.id === balance.id);
                if (balance.taken > 0) {
                    const newTaken = sameMonthlyBalance ?
                        sameMonthlyBalance.taken : 0;
                    balance.taken = newTaken;
                }
                return balance;
            });
            return mergeBalances;
        };

        const fetchMonthlyBalance = (types, reference) => {
            const end = moment(reference).endOf('month').toDate();
            const start = moment(reference).startOf('month').toDate();
            return LeaveRequests.fetchForBalances({
                employee: payslip.getEmployee(),
                typeIds: types.map(t => t.id),
                start,
                end
            }).then((requests) => {
                const simplified = requests.map(request => {
                    const id = request.get('typeId');
                    const taken = request.get('daysRequired');
                    return {
                        id,
                        taken
                    };
                }) || [];
                const groupedById = _.groupBy(simplified, 'id');
                const summedById = _.map(groupedById, requests => {
                    const taken = _.reduce(requests,
                        (sum, request) => sum + request.taken, 0
                    );
                    return {
                        id: requests[0].id,
                        taken
                    };
                });

                return summedById;
            });
        };

        return fetchYearlyBalances()
            .then(yearlyBalances => Promise.all([
                transformYearly(yearlyBalances),
                fetchMonthlyBalance(
                    yearlyBalances,
                    payslip.getPayroll().get('periodDate')
                )
            ]))
            .then(([yearly, monthly]) => mergeBalances(yearly, monthly))
            .then((balances) => {
                this.options.payslipDetails.balances = balances;
            });
    },

    render: function() {
        this.$el.html(template({payslips: this.options.payslips}));

        this.$('.js-employee-select').chosen({width: '100%'});

        this.options.payslipDetails.setPayslip(
            this.options.payslips.first()
        );
        this.options.payslipDetails.fetch()
            .then(() => {
                return this.fetchBalance(this.options.payslips.first());
            })
            .then(() => {
                if (this.activeSlideView) {
                    this.activeSlideView.remove();
                }

                this.activeSlideView = this.renderPayslip(
                    this.options.payslips.first(),
                    this.options.payslipDetails,
                    this.options.balances
                );

                this.toggleSlideButtons(1);
                this.$('.js-slides').removeClass('invisible');
            }).catch(err => {
                Alerts.show('criticalError', err);
            });

        this.$('.js-slides').slick({
            slidesToShow: 1,
            swipe:        false,
            infinite:     false,
            arrows:       false,
            draggable:    false,
            touchMove:    false,
            accesibility: false
        });

        return this;
    },

    renderPayslip: function(payslip, details) {
        var view = new PayslipView({
            model:           payslip,
            payslipDetails:  details,
            companyLocation: this.options.companyLocation
        });

        this.$('.js-slide-' + payslip.id).append(view.$el);

        return view;
    },

    show: function() {
        this.$('.js-slides').slick('setPosition');
        return this;
    },

    selectEmployee: function(ev) {
        const $select = $(ev.currentTarget);
        const payslip = this.options.payslips.at($select.val());
        this.options.payslipDetails.setPayslip(payslip);
        this.options.payslipDetails.fetch()
            .then(() => this.fetchBalance(payslip))
            .then(() => this.$('.js-slides').slick('slickGoTo', $select.val()));
    },

    beforeChangeSlide: function(ev, slick, currentSlide, nextSlide) {
        if (currentSlide !== nextSlide) {
            this.$('.js-employee-select')
                .val(nextSlide)
                .trigger('chosen:updated');
        }

        this.nextSlideView = this.renderPayslip(
            this.options.payslips.at(nextSlide),
            this.options.payslipDetails
        );

        this.toggleSlideButtons(nextSlide + 1);
    },

    afterChangeSlide: function() {
        var prevSlideView = this.activeSlideView;
        this.activeSlideView = this.nextSlideView;

        if (prevSlideView && typeof prevSlideView.remove === 'function') {
            prevSlideView.remove();
        } else {
            log.error('Inconsistent state. Missing previous slide view.');
        }
    },

    prevSlide: function() {
        const payslip = this.options.payslips.at(Math.max(0,
            this.$('.js-slides').slick('slickCurrentSlide') - 1
        ));
        this.options.payslipDetails.setPayslip(payslip);
        this.options.payslipDetails.fetch()
            .then(() => this.fetchBalance(payslip))
            .then(() => this.$('.js-slides').slick('slickPrev'));
    },

    nextSlide: function() {
        const payslip = this.options.payslips.at(Math.min(
            this.options.payslips.length,
            this.$('.js-slides').slick('slickCurrentSlide') + 1
        ));
        this.options.payslipDetails.setPayslip(payslip);
        this.options.payslipDetails.fetch()
            .then(() => this.fetchBalance(payslip))
            .then(() => {
                this.$('.js-slides').slick('slickNext');
            });
    },

    toggleSlideButtons: function(slide) {
        this.$('.js-prev-slide')
            .toggleClass('slick-disabled', (slide === 1))
            .toggleClass('js-disabled', (slide === 1));
        this.$('.js-next-slide')
            .toggleClass(
                'slick-disabled', (slide === this.options.payslips.length)
            )
            .toggleClass(
                'js-disabled', (slide === this.options.payslips.length)
            );
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepTwo/Payslips.js